import { http } from "@/utils/index";

// 查询菜单列表
export function listMenu(query) {
  return http.request("get", "/menu/list", {
    params: query,
  });
}

// 查询菜单详细
export function getMenu(menuId) {
  return http.request("get", "/menu/" + menuId);
}

// 查询菜单下拉树结构
export function treeselect(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/menu/front/tree", {
    params
  });
}

// 新增菜单
export function addMenu(data) {
  return http.request("post", "/menu", {
    data,
  });
}

// 修改菜单
export function updateMenu(data) {
  return http.request("put", "/menu", {
    data,
  });
}

// 删除菜单
export function delMenu(menuId) {
  return http.request("delete", "/menu/" + menuId);
}
